/**
 * IDs at or above this value are reserved for custom PSWs. The builder
 * checks every DATEN-sourced PSW id against this ceiling and throws if a
 * factory PSW ever lands in the reserved range — the reservation only
 * holds if BMW respects the same convention by accident.
 *
 * Empirically observed maximum in real DATEN: ≈ 0x1000-ish. 0xF000 leaves
 * plenty of factory headroom while still giving 4096 custom slots per
 * session.
 */
export const CUSTOM_PSW_ID_BASE = 0xf000;
export class FunctionListError extends Error {
    constructor(message) {
        super(message);
        this.name = 'FunctionListError';
    }
}
//# sourceMappingURL=types.js.map